var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.books)?_c('div',{staticClass:"books-container"},_vm._l((_vm.books),function(book,idx){return _c('article',{key:idx},[_c('Book',{attrs:{"book":book,"areFaves":_vm.areFaves}})],1)}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }